import { fetchJsonApi } from "../apiClient";
import { getLocalDateKey } from "./dailyRandom";

let cachedPage = null;
let cacheDay = null;
let inFlight = null;

async function loadPortfolioPage() {
  const day = getLocalDateKey();
  if (cachedPage && cacheDay === day) {
    return cachedPage;
  }
  if (inFlight) {
    return inFlight;
  }

  const qs = `?day=${encodeURIComponent(day)}`;
  inFlight = fetchJsonApi(`/public/portfolio${qs}`)
    .then((data) => {
      cachedPage = {
        items: Array.isArray(data?.items) ? data.items : [],
        coverHeroUrl:
          typeof data?.coverHeroUrl === "string" && data.coverHeroUrl
            ? data.coverHeroUrl
            : null,
        heroBlurDataUrl:
          typeof data?.heroBlurDataUrl === "string" && data.heroBlurDataUrl
            ? data.heroBlurDataUrl
            : null,
      };
      cacheDay = day;
      return cachedPage;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

/** Stratified portfolio grid items (same response as before). */
export async function getPortfolioItems() {
  const page = await loadPortfolioPage();
  return page.items;
}

/** Warm `/public/portfolio` (same cache as the grid) after idle or nav hover. */
export function prefetchPortfolioIndex() {
  void loadPortfolioPage();
}

/** Home hero background: only an image whose filename is ``cover.jpg`` / ``cover.jpeg`` / ``cover.png`` / ``cover.webp`` (any case). */
export async function getCoverHeroUrl() {
  const page = await loadPortfolioPage();
  return page.coverHeroUrl;
}

/** Tiny base64 blurred preview of the home hero (the top curated item), shown instantly so
 *  the hero never opens on a blank gradient while the real photo downloads. */
export async function getHeroBlurDataUrl() {
  const page = await loadPortfolioPage();
  return page.heroBlurDataUrl;
}
